import { render, staticRenderFns } from "./consolidation.vue?vue&type=template&id=10f9c8ce&"
import script from "./consolidation.vue?vue&type=script&lang=js&"
export * from "./consolidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports